import apiHelper from '../helpers/apiHelper'
import identityConfig from '../config/identity.json'

export default {
  getInfo()
  {
    return apiHelper.request(identityConfig.verificationEndPoint)
  },
  cancelIdentification(verificationId)
  {
    return apiHelper.request(identityConfig.cancelVerificationEndPoint, {id: verificationId}, 'POST')
  },
  createIdentification(verificationId)
  {
    return apiHelper.request(identityConfig.createVerificationEndPoint, {id: verificationId}, 'POST')
  }
}
